import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service'; 
@Component({
  selector: 'app-how-to-get-admission-to-bcom',
  templateUrl: './how-to-get-admission-to-bcom.component.html',
  styleUrls: ['./how-to-get-admission-to-bcom.component.scss']
})
export class HowToGetAdmissionToBcomComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
